const devEnv = {
    userSignupAge: 19,
    
    googleMapKey: 'AIzaSyBJs2f0TNNui_OcRHgVRTIsJAvGQ0EB7oA',
    googleAuthClientId: '798107650474-2s9ggqp33bvrlj2bv5seotc6q2a2lpu0.apps.googleusercontent.com',
    
    facebookAppId: '1156270755104800',

    // business profile 284629430222460
    defaultBusinessSlug: 'budler', //budler
    businessProfileUrl: 'https://auth.dev.api.unoapp.io', 
    businessProfileUrlApiToken: '6090a6ee31d7d70b13857118a7ead5d6a5d83a8a',
    businessNotToRedirect: ['0cdb5e80-a029-4b7d-8d34-c02bfd4078ae'], // do not redirect for this business if has 1 location only

    // Login / user
    loginUrl: 'https://cannabis-users-v3.dev.api.unoapp.io', // old -> https://cannabis-users.dev.v2.api.unoapp.io
    loginAppId: 'a018a0480786fe3feb59304a6f8247d3c402089e',
    loginAppSecret: '0e3da4884456a6cd8a8f00ed4c8e1120ac67b5a3',
    loginApiToken: '7e4c911556985b08ecf4250e1eaf8e62000fae72',
    
    // Product
    productUrl: 'https://cannabis-products.dev.api.unoapp.io',
    productAppId: '19SFVHpxjoPvCTYF3AVBGVhOE5GGr15X',
    productAppSecret: 'JvVCzQZHbvGxZUgFVD2cPjEYAl0IlJHh',
    
    // Location
     //locationUrl: 'https://locations.v2.api.unoapp.io',  // old
     locationUrl: 'https://locations.dev.api.unoapp.io', // changed url old
    // we got new V2 api for location
    //locationUrl: 'https://locations-service.dev.api.unoapp.io',
    //apiToken: '24532268e527bfd9c211f5aacd9b782498e297ce', // old api token
    apiToken: '3e7b388bf0d73acb39d2490b854034a5178a6698', // new api token
    authToken: 'b13b98c95f73e1443c9eab88609ef6047144a5b1',

    // Cart
    cartUrl: 'https://cannabis-cart.dev.v2.api.unoapp.io',

    // User
    appVersion: '2.8.2',
    appPlatform: 'web',
    
    // Pubnub
    pubnubSubscribeKey: 'sub-c-ae54d434-1bbf-11ea-a8ee-866798696d74',
    pubnubPublishKey: 'pub-c-9e313ac6-95b2-4adb-b3d5-f7409d776d44',

    // Order url
    orderUrl: 'https://cannabis-orders.dev.v2.api.unoapp.io',

    // Promocode
    promoCodeUrl: 'https://promocodes.dev.v2.api.unoapp.io',
    promoCodeApiToken: 'TRgl5ffTlLakbNMB1z6LRkj9pA3i1MNf',
    
    // Business id
    businessId: '30a725ca-3027-4aa5-a5fe-1eab625e4e79',
    moneris: {
      id: 'ht3E8Z8OZSAH77N',
      url: 'https://esqa.moneris.com/HPPtoken/index.php', // qa url
    },
    paysafe: {
      url: 'https://hosted.paysafe.com/js/v1/latest/paysafe.min.js',
      username: 'OT-327700',
      password: 'B-qa2-0-5ec3f480-0-302c0214155be72773dfa195c1fbd6bf1baa7d6f013fb7ce0214667cf3b9401ba32bf848312b9e4be754cbb834de', // qa url
      apiKey: 'T1QtMzI3NzAwOkItcWEyLTAtNWVjM2Y0ODAtMC0zMDJjMDIxNDE1NWJlNzI3NzNkZmExOTVjMWZiZDZiZjFiYWE3ZDZmMDEzZmI3Y2UwMjE0NjY3Y2YzYjk0MDFiYTMyYmY4NDgzMTJiOWU0YmU3NTRjYmI4MzRkZQ==',
      options: {
        environment: "TEST",
        fields: {
          cardNumber: {
            selector: "#cardNumber",
            placeholder: "Card number"
          },
          expiryDate: {
            selector: "#expiryDate",
            placeholder: "Expiry date"
          },
          cvv: {
            selector: "#cvv",
            placeholder: "CVV"
          }
        }, 
        style: {
          input: {
            "font-family": "robotoregular,Helvetica,Arial,sans-serif",
            "font-weight": "200",
            "font-size": "15px",
            "color": "#333",
          }
        }
      },
    },

    elavon:{
      tokenurl: 'https://api.demo.convergepay.com/hosted-payments/transaction_token',
      jsurl:'https://api.demo.convergepay.com/hosted-payments/Checkout.js',
      ssl_merchant_id: '0022765',
      ssl_user_id: 'apiuser',
      ssl_pin: 'WHZOY81PEWGZDA9GTDKWPBFC2VJ9VDY9JF0FKE29DHD9EM76BIPO1PJYCIYUMZZX',
      ssl_transaction_type: 'ccgettoken',
    },

    clover: {
      sdkUrl: 'https://checkout.sandbox.dev.clover.com/sdk.js',
      merchantId: '8baf4e5272eb8deaf4dfbac0503c28c9',
    },
    
    // Promotion   
    promotion: {
      url: 'https://promotions.dev.api.unoapp.io',
      api_token: 'Rks9wYfzmRsdJ23Jfs8Dhe&Djk9dsfk1Gdiwe7H',
    }, 

    vbout:{
      url: 'https://forwarder.dev.api.unoapp.io',
      api_key: '5238320008277607645120542',
      domain: 'VBT-52043-5330',
      domain_url: 'https://unohop.dev.unoapp.io',
    },

    loyality: {
      api_token: '7e4c911556985b08ecf4250e1eaf8e62000fae72',
    },

    businessLoyality: {
      url: 'https://loyalty-service.dev.api.unoapp.io'
    },

    fiska: {
      terminalId: '1064A24',
      secret: '123456789G1LOJ90',
      merchantId: '1064',
      merchantRef: '1234321',
    },
    
    /**
    *  ======================================== NOT NEEDED / COMING SOON BELOW THIS =============================
    */


    // FAQ    
    faqUrl: 'https://faq.dev.api.unoapp.io',

    // Review
    reviewUrl: 'https://product-reviews.dev.api.unoapp.io',
    reviewAppId: 'a507afee6cdd53b69e5b4f0b761631aa7a3d3ddd',
    reviewAppSecret: 'bb1fa5d68702c0aefd0339c65ebc99a6be20162b',

    // Notifications
    notificationUrl: 'https://notifications.dev.api.unoapp.io',
    notificationToken: 'cbfe048b4cdcf06e8e86962e35fca040',

    // Support
    supportEmail: 'info@budler.ca',
    
}
export default devEnv;